/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getEditDropinMountedPromise } from "selectors/overlayDropinSelectors";

export const getEditApis = stores => {
  const editDropinMountedPromise = getEditDropinMountedPromise(stores);

  function preloadEdit(opts) {
    return editDropinMountedPromise.promise.then(apis => apis.preloadEdit(opts));
  }

  function insertText(text, clickPoint, pageIndex, opts) {
    return editDropinMountedPromise.promise.then(apis => {
      const { x, y } = clickPoint;
      const quads = [[x, y, x, y, x, y, x, y]];
      return apis.replaceText(text, quads, pageIndex, opts);
    });
  }

  function replaceText(text, quads, pageIndex, opts) {
    return editDropinMountedPromise.promise.then(apis => apis.replaceText(text, quads, pageIndex, opts));
  }

  function deleteText(quads, pageIndex, opts) {
    return editDropinMountedPromise.promise.then(apis => apis.replaceText("", quads, pageIndex, opts));
  }

  function discardPreview() {
    return editDropinMountedPromise.promise.then(apis => apis.discardPreview());
  }

  return {
    edit: {
      getEditDropinMountedPromise: () => editDropinMountedPromise,
      preloadEdit,
      insertText,
      replaceText,
      deleteText,
      discardPreview
    }
  };
};
